import { api } from '$utils/apiRequester'

export const LOAD_PROJECTS_REQUEST = 'LOAD_PROJECTS_REQUEST'
export const LOAD_PROJECTS_SUCCESS = 'LOAD_PROJECTS_SUCCESS'
export const LOAD_PROJECTS_FAILURE = 'LOAD_PROJECTS_FAILURE'

export const LOAD_SEARCHED_PROJECTS_REQUEST = 'LOAD_SEARCHED_PROJECTS_REQUEST'
export const LOAD_SEARCHED_PROJECTS_SUCCESS = 'LOAD_SEARCHED_PROJECTS_SUCCESS'
export const LOAD_SEARCHED_PROJECTS_FAILURE = 'LOAD_SEARCHED_PROJECTS_FAILURE'

export const EMPTY_PROJECTS = 'EMPTY_PROJECTS'

export const loadProjects = ({
  extraFields = '',
  filter = '',
  id,
  isAuthenticated = false,
  lang = '',
  limit = 9,
  next,
  sort = ''
}) => {
  // prettier-ignore
  const params = next || `?state=${filter}${sort ? `&sort=${sort}` : ''}&limit=${limit}${extraFields ? `&extra_fields=${extraFields}` : ''}${lang ? `&lang=${lang}` : ''}`
  return {
    types: [LOAD_PROJECTS_REQUEST, LOAD_PROJECTS_SUCCESS, LOAD_PROJECTS_FAILURE],
    promise: () =>
      api('ulule').get(`/users/${id}/projects${params}`, {
        withAccessToken: isAuthenticated
      })
  }
}

export const emptyProjects = () => ({
  type: EMPTY_PROJECTS
})

export const searchProjects = (params = '', extraFields = '', limit = 10, offset = 0) => {
  const _params = params ? `&q=${params}` : ''
  return {
    types: [LOAD_SEARCHED_PROJECTS_REQUEST, LOAD_SEARCHED_PROJECTS_SUCCESS, LOAD_SEARCHED_PROJECTS_FAILURE],
    promise: () =>
      api('ulule').get(`/search/projects?limit=${limit}&offset=${offset}&extra_fields=${extraFields}${_params}`, {
        withAccessToken: true
      })
  }
}
